import { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { SbRespStickyMenu } from '../SbRespStickyMenu/SbRespStickyMenu';
import { SbRespRefineMenu } from '../SbRespRefineMenu/SbRespRefineMenu';
import { SbSharedSkyscraperAd } from '../SbSharedSkyscraperAd/SbSharedSkyscraperAd';

import styles from './SbRespRefineMenuSelector.scss';

function SbRespRefineMenuSelectorComponent({
    currency,
    itemSearch,
    viewer,
    user,
    isClient,
    uriRef,
    isThinPage,
}) {
    const { isTablet, isSbUsabilityUpdatesVariant } = useContext(ServerVarsContext);
    const { filters } = itemSearch;
    const { isSkyscraperAdEnabled } = viewer;
    const sharedProps = {
        currency,
        itemSearch,
        viewer,
        user,
        isClient,
    };

    const renderMenuSelectorContent = () => (
        <>
            {/* Refine Menu */}
            <SbRespRefineMenu {...sharedProps} filters={filters} uriRef={uriRef} />

            {/* Ad */}
            {!isThinPage && isSkyscraperAdEnabled && (
                <SbSharedSkyscraperAd itemSearch={itemSearch} />
            )}
        </>
    );

    if (isTablet) {
        return <div className={styles.refineMenuContainer}>{renderMenuSelectorContent()}</div>;
    }

    if (isSbUsabilityUpdatesVariant) {
        return <div className={styles.wrapper}>{renderMenuSelectorContent()}</div>;
    }

    return <SbRespStickyMenu>{renderMenuSelectorContent()}</SbRespStickyMenu>;
}

SbRespRefineMenuSelectorComponent.propTypes = {
    currency: PropTypes.string.isRequired,
    itemSearch: PropTypes.shape({
        filters: PropTypes.array.isRequired,
    }).isRequired,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    isClient: PropTypes.bool,
    uriRef: PropTypes.string,
    isThinPage: PropTypes.bool.isRequired,
};

export const SbRespRefineMenuSelector = createFragmentContainer(SbRespRefineMenuSelectorComponent, {
    itemSearch: graphql`
        fragment SbRespRefineMenuSelector_itemSearch on ItemSearchQueryConnection {
            ...SbRespRefineMenu_itemSearch
            ...SbSharedSkyscraperAd_itemSearch
            filters {
                ...SbRespRefineMenu_filters
            }
        }
    `,
    user: graphql`
        fragment SbRespRefineMenuSelector_user on User {
            ...SbRespRefineMenu_user
        }
    `,
    viewer: graphql`
        fragment SbRespRefineMenuSelector_viewer on Viewer {
            isSkyscraperAdEnabled: isEnabledByLocale(featureName: "NON_MVP_SEARCH_BROWSE")
            ...SbRespRefineMenu_viewer
        }
    `,
});
